import { ReactElement } from 'react';
import ModalImg from 'src/assets/images/create-menu-item-modal.png';
import { Modal } from '@weareopenr/component-library';
import VenueCreateForm from '../VenueCreateForm';

export const CreateVenueModal = ({ closeModal, open }): ReactElement => (
  <Modal closeModal={closeModal} open={open} image={ModalImg} imageAlt="Picture of ingredient">
    <VenueCreateForm />
  </Modal>
);
